<template>
    <div>
        <div v-if="queries">
            <ul class="list-group">
                <li v-for="query in queries" class="list-group-item mb-2" :class="status(query)" @click="changeActive(query.id)">
                    <query-card-component :key="query.id" :query="query" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import QueryCardComponent from './QueryCard';
    import EventBus from '../../EventBus';

    export default {
        data() {
            return {
                active: null
            }
        },
        props: ['queries'],
        components: {
            QueryCardComponent
        },
        methods: {
            status(query) {
                return {
                    unread: query.status == 'unread',
                    read: query.status == 'read',
                }
            },
            changeActive(id) {
                this.active = id;
            }
        },
        created() {
            EventBus.$on('ACTIVE_QUERY_TO_NULL', this.changeActive)
        },
        beforeDestroy() {
            EventBus.$off('ACTIVE_QUERY_TO_NULL', this.changeActive)
        }
    }
</script>

<style scoped>
.list-group-item:hover{
    cursor: pointer;
    background: #eee;
    color: black;
}
/*.active{
    background-color: #5FA963 !important;
    color: white !important;
    border-color: rgb(0, 85, 4);
}*/
.read{
    background-color: #EBEBEB;
    color: black;
    border-color: rgb(176, 193, 176);
    border: 2px solid #b8b8b8;
    border-radius: 10px;
    opacity: 1;
}
.unread{
    background-color: #EBEBEB;
    color: black;
    border-color: rgb(176, 193, 176);
    border: 3px solid #5FA963;
    border-radius: 10px;
    opacity: 1;
}
</style>
